import React, { useEffect, useState } from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { api } from '@/lib/api';
import { fmtDate } from '@/lib/format';
import { TID } from '@/lib/testIds';
import { X } from 'lucide-react';

export default function AdminEmailLogPage() {
  const [logs, setLogs] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get('/admin/email-log').then(({ data }) => setLogs(data || [])); }, []);

  return (
    <AdminLayout>
      <div data-testid={TID.admin.emailLogPage}>
        <h1 className="font-display text-3xl text-white">EMAIL LOG</h1>
        <p className="text-sm text-white/65 mb-5">All outbound notifications. STATUS shows whether the message was actually sent via a configured provider, or stubbed (logged in DB / backend logs).</p>
        <div className="sb-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-[11px] uppercase tracking-widest text-white/55 bg-black/30">
              <tr>
                <th className="text-left px-4 py-3">Time</th>
                <th className="text-left px-4 py-3">To</th>
                <th className="text-left px-4 py-3">Template</th>
                <th className="text-left px-4 py-3">Subject</th>
                <th className="text-left px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} onClick={() => setActive(l)} className="border-t border-[hsl(var(--sb-border))] hover:bg-white/5 cursor-pointer">
                  <td className="px-4 py-3 text-white/85">{fmtDate(l.created_at)}</td>
                  <td className="px-4 py-3 text-white">{l.to}</td>
                  <td className="px-4 py-3 text-white/85">{l.template}</td>
                  <td className="px-4 py-3 text-white truncate max-w-md">{l.subject}</td>
                  <td className="px-4 py-3"><span className="text-[11px] uppercase tracking-wider font-semibold text-[hsl(var(--sb-gold))]">{l.status}</span></td>
                </tr>
              ))}
              {!logs.length && <tr><td colSpan={5} className="py-10 text-center text-white/55">No emails logged yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex justify-end" onClick={() => setActive(null)}>
          <div className="w-full max-w-2xl bg-[hsl(var(--sb-surface))] h-full overflow-y-auto border-l border-[hsl(var(--sb-border))]" onClick={(e) => e.stopPropagation()}>
            <div className="p-5 border-b border-[hsl(var(--sb-border))] flex items-center justify-between">
              <div>
                <div className="font-display text-xl text-white">{active.subject}</div>
                <div className="text-xs text-white/55 mt-1">{active.template} → {active.to}</div>
              </div>
              <button onClick={() => setActive(null)} className="h-9 w-9 grid place-items-center text-white/70"><X size={18} /></button>
            </div>
            <div className="p-5">
              <pre className="text-xs text-white/75 whitespace-pre-wrap break-words bg-black/40 p-4 rounded-md">{JSON.stringify(active.payload, null, 2)}</pre>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
